<router-outlet />
<p-toast position="top-center" />
<p-confirm-dialog />
